import React, { useState, useEffect } from "react";
import { classNames } from "utils/utils";
import SkeletonLoader from "components/skeletonLoader";
import { useGame } from "context/gameContext";
import { useTranslation } from "react-i18next";

const UserList = ({ participants, isLoading, extra }) => {
  const { t, i18n } = useTranslation();

  const tournamentParticipants = participants.map((item) => {
    return (
      <div className="flex flex-col w-12 mb-2 mr-2 items-center" key={item.id}>
        <div className="grid grid-cols-1 justify-items-end items-end">
          <img
            src={item?.photo}
            className={classNames(
              item.gameOver ? "grayscale opacity-50" : "",
              "w-10 h-10 rounded-full row-start-1 col-start-1"
            )}
          />
          <div
            className={classNames(
              item.gameOver
                ? "!bg-red-500 rounded-sm shadow-sm"
                : item.drawCount == 1
                ? "!bg-yellow-400 rounded-sm shadow-sm"
                : "",
              " w-3 h-4 text-xs justify-center items-center  flex text-white   -mb-1 -mr-0.5 row-start-1 col-start-1 leading-none z-10"
            )}
          ></div>
        </div>

        <div className="text-xs pt-1 w-12 text-center truncate text-black">
          {item?.nickname}
        </div>
      </div>
    );
  });

  return (
    <div className="flex w-full flex-wrap ">
      {isLoading ? (
        <div className="flex mr-2 mb-2">
          <SkeletonLoader type={"userCard"} amount={3} horizontal={true} />
        </div>
      ) : (
        <div className="flex flex-row flex-wrap">
          {tournamentParticipants.length ? tournamentParticipants : "-"}
          {extra > 25 && (
            <div className="flex flex-col w-fit mb-2 mr-2 items-center justify-center text-xs text-center">
              <div className="flex">{"+" + extra - 25}</div>
              <div className="flex">
                {t("lobby.card.players", {
                  count: 2,
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserList;
